<ul>
  @for (item of menuItems; track item.title) {
    <li
      #target
      (pointerenter)="onMouseEnter($event, item)"
      (pointerleave)="onMouseLeave($event, item)"
    >
      @if (item.isSection) {
        <span class="aos-side-menu-section">{{ item.title | translate | uppercase }}</span>
      } @else {
        <ng-container
          *ngTemplateOutlet="anchorTemplate; context: { menuItem: item, isContextMenuItem: false, target: target }"
        />
      }
    </li>
  }
</ul>

<ng-template
  #anchorTemplate
  let-menuItem="menuItem"
  let-isContextMenuItem="isContextMenuItem"
  let-target="target"
>
  @if (menuItem.isNonNavigable) {
    <div [ngClass]="getClassBindings(menuItem, isContextMenuItem)">
      <ng-container
        *ngTemplateOutlet="
          itemContainerTemplate;
          context: { isContextMenuItem: isContextMenuItem, menuItem: menuItem, target: target }
        "
      ></ng-container>
    </div>
  } @else if (menuItem.hasExternalLink) {
    <a
      [ngClass]="getClassBindings(menuItem, isContextMenuItem)"
      [href]="menuItem.path"
      target="_blank"
      (click)="handleClick($event, menuItem)"
    >
      <ng-container
        *ngTemplateOutlet="
          itemContainerTemplate;
          context: { isContextMenuItem: isContextMenuItem, menuItem: menuItem, target: target }
        "
      ></ng-container>
    </a>
  } @else {
    <a
      #rla="routerLinkActive"
      [ngClass]="getClassBindings(menuItem, isContextMenuItem)"
      routerLinkActive=""
      [routerLinkActiveOptions]="{
        paths: 'subset',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored'
      }"
      [routerLink]="menuItem.path"
      (click)="handleClick($event, menuItem)"
    >
      <ng-container
        *ngTemplateOutlet="
          itemContainerTemplate;
          context: { isContextMenuItem: isContextMenuItem, menuItem: menuItem, target: target }
        "
      ></ng-container>
    </a>
  }
</ng-template>

<ng-template
  #itemContainerTemplate
  let-isContextMenuItem="isContextMenuItem"
  let-menuItem="menuItem"
  let-target="target"
>
  @if (!isContextMenuItem) {
    <ng-container
      *ngTemplateOutlet="
        itemContentTemplate;
        context: {
          iconColor: menuItem.hasSelectedChild || menuItem.selected ? selectedItemIconColor : itemIconColor,
          iconName: menuItem.icon ? menuItem.icon : '',
          title: menuItem.title
        }
      "
    />
  } @else {
    <ng-container *ngTemplateOutlet="subitemContentTemplate; context: { title: menuItem.title }" />
  }

  @if (menuItem.children.length && showPopup && activePopupItem === menuItem) {
    <kendo-popup
      #popup
      class="aos-side-menu-popup"
      popupClass="aos-side-menu-popup__content"
      [anchorAlign]="{ horizontal: 'right', vertical: 'top' }"
      [anchor]="target"
      [margin]="{ horizontal: 0, vertical: 0 }"
      [animate]="{
        type: 'expand',
        duration: 150,
        direction: 'right'
      }"
    >
      <ul>
        @for (item of menuItem.children; track item.title) {
          <li>
            <ng-container
              *ngTemplateOutlet="anchorTemplate; context: { menuItem: item, isContextMenuItem: true, target: target }"
            />
          </li>
        }
      </ul>
    </kendo-popup>
  }
</ng-template>

<ng-template
  #itemContentTemplate
  let-iconColor="iconColor"
  let-iconName="iconName"
  let-title="title"
>
  <!-- TODO: Do we need `role="button"`? -->
  <div
    class="aos-side-menu-item__content"
    role="button"
  >
    <ui-icon
      class="aos-side-menu-item__icon"
      [color]="iconColor"
      [name]="iconName"
      [size]="itemIconSize"
    />
    <span class="aos-side-menu-item__title">{{ title | translate }}</span>
  </div>
</ng-template>

<ng-template
  #subitemContentTemplate
  let-title="title"
>
  <!-- TODO: Do we need `role="button"`? -->
  <div role="button">
    <span class="aos-side-menu-subitem__title">{{ title | translate }}</span>
  </div>
</ng-template>
